import { NO_APLICA } from './constants'
import { slugify } from './dataLayer'
import type { ClickEventParams } from './types'

/** Dominio destino de una URL absoluta; `no_aplica` para enlaces internos (relativos). */
export function resolveLinkDomain(href: string): string {
  try {
    return /^https?:\/\//i.test(href) ? new URL(href).hostname : NO_APLICA
  } catch {
    return NO_APLICA
  }
}

interface LinkClickInput {
  readonly clickType: string
  readonly clickSubtype?: string
  readonly label: string
  readonly href: string
  readonly moduleName: string
  readonly actionDetail?: string
}

/**
 * Construye los 12 params fijos del `click` para un enlace (guía `click`):
 * `link_text` slugificado, `link_url` tal cual (relativa si es interna, completa
 * si es outbound) y `link_domain` solo en outbound.
 */
export function buildLinkClick({
  clickType,
  clickSubtype = NO_APLICA,
  label,
  href,
  moduleName,
  actionDetail = NO_APLICA,
}: LinkClickInput): ClickEventParams {
  return {
    click_type: clickType,
    click_subtype: clickSubtype,
    link_text: slugify(label),
    link_url: href,
    link_domain: resolveLinkDomain(href),
    module_name: moduleName,
    module_type: NO_APLICA,
    nav_level: NO_APLICA,
    nav_path: NO_APLICA,
    action_detail: actionDetail,
    action_value: NO_APLICA,
    action_context: NO_APLICA,
  }
}
